module.exports = __webpack_public_path__ + "static/media/video.6419ee8f.mp4";